<template>
	<footer class="bg-gray-100 relative">
		<div class=" lg:mx-auto mx-5 grid lg:grid-cols-4 gap-x-auto py-10 lg:px-28 grid-cols-1">
			<div>
				<router-link to="/" class="inline-block">
					<img src="@/assets/rdna-logo.png" class="saturate-0 brightness-[70%] contrast-[1000%]" alt="Rdna">
				</router-link>
				<!-- start description -->
				<p class="text-sm text-dark-gray-4 my-7 leading-6" v-if="footerData?.description?.length > 0">
					{{ footerData?.description }}
				</p>
				<!-- description skeleton -->
				<p class="text-sm text-dark-gray-4 my-7 leading-6 shadow skeleton-box w-[283px] h-[15px]"
					v-if="!footerData"></p>
				<p class="text-sm text-dark-gray-4 my-7 leading-6 shadow skeleton-box w-[283px] h-[15px]"
					v-if="!footerData"></p>
				<p class="text-sm text-dark-gray-4 my-7 leading-6 shadow skeleton-box w-[80px] h-[15px]"
					v-if="!footerData"></p>
				<!-- end description -->

				<div class="flex justify-start items-center social mb-5">
					<a href="https://fb.com" target="_blank" class="me-6">
						<font-awesome-icon :icon="['fab', 'facebook-f']" class="text-black fa-1x ms-1" />
					</a>
					<a href="https://twitter.com" target="_blank" class="me-6">
						<font-awesome-icon :icon="['fab', 'twitter']" class="text-black fa-1x ms-1" />
					</a>
					<a href="https://instagram.com" target="_blank" class="me-6">
						<font-awesome-icon :icon="['fab', 'instagram']" class="text-black fa-1x ms-1" />
					</a>
				</div>
			</div>
			<div class="lg:mx-auto mb-10">
				<h6 class=" text-secondary mb-7 font-bold">{{ $t('footer.Categories') }}</h6>
				<div class="grid grid-cols-1 gap-y-5 text-sm text-secondary">
					<a v-for="link of footerData?.department" :key="link.id" :href="link.url"
						class=" hover:underline">{{ link.title }}</a>
					<!-- skeleton -->
					<p v-if="!footerData" v-for="(link, index) of ['', '', '']" :key="index"
						class="skeleton-box shadow w-[115px] h-[15px]"></p>
				</div>
			</div>
			<div class="lg:mx-auto mb-10">
				<h6 class=" text-secondary mb-7 font-bold">{{ $t('footer.About') }}</h6>
				<div class="grid grid-cols-1 text-sm gap-y-5">
					<a v-for="link of footerData?.about" :key="link.id" :href="link.url"
						class=" hover:underline">{{ link.title }}</a>
					<!-- skeleton -->
					<p v-if="!footerData" v-for="(link, index) of ['', '', '']" :key="index"
						class="skeleton-box shadow w-[115px] h-[15px]"></p>

				</div>
			</div>
			<div class="lg:mx-auto mb-10">
				<h6 class=" text-secondary mb-7 font-bold">{{ $t('footer.Customer_care') }}</h6>
				<div class="grid grid-cols-1 text-sm gap-y-5">
					<a v-for="link of footerData?.customers_service" :key="link.id" :href="link.url"
						class=" hover:underline">{{ link.title }}</a>
					<!-- skeleton -->
					<p v-if="!footerData" v-for="(link, index) of ['', '', '']" :key="index"
						class="skeleton-box shadow w-[115px] h-[15px]"></p>
				</div>
			</div>
		</div>
	</footer>
	<footer class="bg-dark-4 py-2 lg:py-4 lg:px-28 px-5 bottom-footer relative">
		<div class=" text-center text-white text-sm" v-if="footerData?.Reserved?.length > 0">
			{{ footerData?.Reserved }}
		</div>
		<!-- reserved skeleton -->
		<div v-if="!footerData" class="skeleton-box shadow w-[179px] h-[15px]  mx-auto"></div>
	</footer>
</template>

<script>
import { onBeforeMount, ref, computed } from "vue";
import Request from "@/common/Request"

export default {
	name: "landing-footer",
	setup() {
		// footer data
		const footerData = ref(null)
		const isHasFooterData = computed(() => { return Object.keys(footerData?.value)?.length > 0 ? true : false })

		onBeforeMount(async () => {
			//get footer data
			const footerDataApi = await new Request().get("homepage/footer") || {}
			const footerListsApi = await new Request().get("menu/footer") || {}

			Promise.all([footerDataApi, footerListsApi]).then((response) => {
				footerData.value = { ...response[0]?.data?.data, ...response[1]?.data?.data };
			}).catch((err) => {
			});
		});
		return {
			footerData,
			isHasFooterData,
		}
	}
}
</script>

<style scoped>
.social svg {
	@apply text-dark-gray-3 text-lg
}
</style>